export default __webpack_public_path__ + "static/media/img--design-6.902bf39f.jpg";